import { useState } from 'react'
import { useVerifyEmail } from '../hooks/useVerifyEmail'

const VerifyEmail = () => {
    const [otp, setOtp] = useState('')
    const {verifyEmail, error, isLoading} = useVerifyEmail()
    const [message, setMessage] = useState(null)
    const [disabled, setDisabled] = useState(false)
    const [messageStyle, setMessageStyle] = useState()

    const handleSubmit = async (e) => {
        e.preventDefault()
        await verifyEmail(otp)
    }

    const handleResend = async (e) => {
        if (disabled) {
            return
        }
        setDisabled(true)
        setMessageStyle('message-loading')
        setMessage('Loading...')
        const resend_response = await fetch(`${process.env.REACT_APP_API_URL}/api/user/send-verify-otp`, {
            method: 'POST',
            credentials: 'include'
        })
        if (!resend_response.ok) {
            setMessageStyle('message-fail')
            setMessage('email verification code failed to send. Re-try in 60 seconds.')
            return
        }
        setMessageStyle('message-success')
        setMessage('Email verification code has been sent')
        setTimeout(() => {
            setMessage(null)
            setDisabled(false)
        }, 60000)
        return
    }

    return (
        <form className="verificationOtp" onSubmit={handleSubmit}>
            <h3>Email Verification</h3>
            <div className="email-verification-input-section">
                <label>Enter email verification code</label>
                <input type="text" onChange={(e) => setOtp(e.target.value)} value={otp} />
            </div>
            <button type="submit" disabled={isLoading}>Submit</button>
            {!disabled && 
            <div className="resend-code">
                <p>Didn't receive a code?</p>
                <button type="button" onClick={() => handleResend()}>Resend</button>
            </div>}
            <p className={`message-text ${messageStyle}`}>{message}</p>
            {error && <div className="error">{error}</div>}
        </form>
    )
}

export default VerifyEmail